//@ts-check

class UserUnitsService {
	constructor($http, $timeout, Utility, $rootScope, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {}

	async getUserUnits() {
		let unitList;

		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const user = this.LocalStorageService.retrieve('userProfile');
			if (user) {
				user.BuildingProfiles.forEach((buildingProfile) => {
					if (!unitList) {
						unitList = [];
					}
					const schemeName = buildingProfile.SchemeName;
					const units = buildingProfile.BuildingProfileUnit;
					const schemeReference = buildingProfile.SchemeReference;

					let buildingUnitList = [];

					units.forEach((unit) => {
						const temp = {
							SchemeName: schemeName,
							CardCode: unit.CardCode,
							SchemeReference: schemeReference
						};

						buildingUnitList = [ ...buildingUnitList, temp ];
					});

					unitList = [ ...unitList, ...buildingUnitList ];
				});
			} else {
				unitList = [];
			}

			this.$timeout(() => {
				promiseHandler.resolve(unitList);
			});
		} catch (err) {
			this.$timeout(() => {
				promiseHandler.reject(err);
			});
		}

		return promise;
	}

	async getFriendlyUnitNames() {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('GetFriendlyUnitNames');
			if (!url) {
				await this.InternalLinksService.getLinks('api/tenant/links', false);
				url = await this.InternalLinksService.getLink('GetFriendlyUnitNames');
			}

			const cardCodes = await this.getFriendlyUnitNamesStringArray();

			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.post(url, cardCodes, { headers });
			const { data } = results;
			this.$timeout(() => promiseHandler.resolve(data));
		} catch (error) {
			const msg = `Could not get friendly unit names.`;
			console.error(msg, error);
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async getFriendlyUnitNamesStringArray() {
		const cardCodes = await this.getUserUnits();
		const stringCardCodes = this._cardCodesToString(cardCodes);

		return stringCardCodes;
	}

	async getFriendlyUnitNamesWithUserBuildingNames() {
		let unitsWithDistinctBuildings;

		const allUserUnits = await this.getUserUnits();
		const buildings = allUserUnits.map((unit) => unit.SchemeReference);
		unitsWithDistinctBuildings = buildings.map((building) => {
			const units = allUserUnits.filter((unit) => unit.SchemeReference === building);

			return {
				units: units.map((unit) => unit.CardCode),
				building
			};
		});

		return unitsWithDistinctBuildings;
	}

	_cardCodesToString(cardCodes) {
		const mapped = cardCodes.map((cardCode) => {
			const { CardCode } = cardCode;
			return CardCode;
		});

		return mapped;
	}
}

export default /* @ngInject */ ($http, $timeout, Utility, $rootScope, LocalStorageService, InternalLinksService) =>
	new UserUnitsService($http, $timeout, Utility, $rootScope, LocalStorageService, InternalLinksService);
